import React, { useState, useEffect } from 'react';
import { getTeacherRatings } from '../../api';
import { toast } from 'react-toastify';

const ViewRatings = () => {
  const [ratings, setRatings] = useState([]);

  useEffect(() => { loadRatings(); }, []);

  const loadRatings = async () => {
    try {
      const res = await getTeacherRatings();
      setRatings(res.data);
    } catch (err) {
      toast.error('Error loading ratings');
    }
  };

  const getAverage = (teacherName) => {
    const teacherRatings = ratings.filter(r => r.teacher_name === teacherName);
    if (teacherRatings.length === 0) return 0;
    const sum = teacherRatings.reduce((acc, r) => acc + r.rating, 0);
    return (sum / teacherRatings.length).toFixed(1);
  };

  const uniqueTeachers = [...new Set(ratings.map(r => r.teacher_name))];

  const renderStars = (rating) => {
    return '⭐'.repeat(Math.round(rating)) + '☆'.repeat(5 - Math.round(rating));
  };

  return (
    <div>
      <h3 style={styles.title}>⭐ Teacher Ratings</h3>
      <p style={styles.subtitle}>
        These ratings are private — only admin can see them
      </p>

      {uniqueTeachers.length === 0 && (
        <div style={styles.empty}>No ratings received yet!</div>
      )}

      {uniqueTeachers.map(teacher => {
        const teacherRatings = ratings.filter(r => r.teacher_name === teacher);
        const avg = getAverage(teacher);
        return (
          <div key={teacher} style={styles.teacherCard}>
            <div style={styles.teacherHeader}>
              <div style={styles.avatar}>
                {teacher?.charAt(0).toUpperCase()}
              </div>
              <div>
                <h4 style={styles.teacherName}>{teacher}</h4>
                <p style={styles.avgRating}>
                  Average: {renderStars(avg)} ({avg}/5)
                </p>
                <p style={styles.totalRatings}>
                  Total Reviews: {teacherRatings.length}
                </p>
              </div>
            </div>

            <div style={styles.ratingsList}>
              {teacherRatings.map(r => (
                <div key={r.id} style={styles.ratingItem}>
                  <div style={styles.ratingHeader}>
                    <span style={styles.studentName}>
                      Student: {r.student_name}
                    </span>
                    <span style={styles.stars}>
                      {renderStars(r.rating)} ({r.rating}/5)
                    </span>
                  </div>
                  {r.feedback && (
                    <p style={styles.feedback}>"{r.feedback}"</p>
                  )}
                  <p style={styles.date}>
                    {new Date(r.created_at).toLocaleDateString()}
                  </p>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const styles = {
  title: { color: '#1a3a5c', marginBottom: '5px' },
  subtitle: { color: '#dc3545', fontSize: '13px', marginBottom: '20px', fontStyle: 'italic' },
  empty: { textAlign: 'center', color: '#999', padding: '40px', background: 'white', borderRadius: '12px' },
  teacherCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  teacherHeader: { display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px', paddingBottom: '15px', borderBottom: '1px solid #eee' },
  avatar: { width: '50px', height: '50px', borderRadius: '50%', background: '#1a3a5c', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold' },
  teacherName: { color: '#1a3a5c', margin: '0 0 5px', fontSize: '18px' },
  avgRating: { color: '#f5a623', margin: '0 0 3px', fontSize: '14px' },
  totalRatings: { color: '#666', margin: 0, fontSize: '13px' },
  ratingsList: { display: 'flex', flexDirection: 'column', gap: '10px' },
  ratingItem: { background: '#f8f9fa', borderRadius: '8px', padding: '12px' },
  ratingHeader: { display: 'flex', justifyContent: 'space-between', marginBottom: '5px' },
  studentName: { color: '#444', fontSize: '13px', fontWeight: '600' },
  stars: { color: '#f5a623', fontSize: '13px' },
  feedback: { color: '#555', fontSize: '13px', fontStyle: 'italic', margin: '5px 0' },
  date: { color: '#999', fontSize: '12px', margin: 0 },
};

export default ViewRatings;